import { useCountryStore } from "@func-core/core/data/repositories";
import { DEFAULT_COUNTRY } from "@func-core/core/domain/constants";
import { Country, CountrySource, CountrySourceType } from "@func-core/core/domain/view-models";
import { Events, track } from "@utils/analytics";

type UseCountryResult = {
  country: Country;
  source: CountrySourceType;
  setCountryState: (country: Country, source: CountrySourceType) => void;
};

export const useCountry = (): UseCountryResult => {
  const { country, source, setCountryState: internalSetCountryState } = useCountryStore();

  const setCountryState = (country: Country, source: CountrySourceType) => {
    internalSetCountryState(country, source);

    track(Events.COUNTRY_DETECTED, {
      country,
      source,
    });
  };

  return {
    country: country ?? DEFAULT_COUNTRY,
    source: source ?? CountrySource.DEFAULT,
    setCountryState,
  };
};
